// extracted by mini-css-extract-plugin
module.exports = {"count":"WordCounter_count__apdEM","count-in-words":"WordCounter_count-in-words__wrBWA"};